import { EventPreparationPanel } from './EventPreparationPanel';

export default function EventDraftLab() {
  return <div className="max-w-4xl mx-auto p-4"><EventPreparationPanel /></div>;
}
